import {Action} from "redux";
import {GetCustomersByIpoCampaignPageRequest} from "../request/customer_request";
import {GetCustomersByClientIpoCampaignPageResponse} from "../response/customer_response";

export enum ClientIpoCampaignActionType {
    REQUEST_GET_CUSTOMERS = "CLIENT_IPO_CAMPAIGN_REQUEST_GET_CUSTOMERS",
    CALLBACK_GET_CUSTOMERS = "CLIENT_IPO_CAMPAIGN_CALLBACK_GET_CUSTOMERS",
}

export interface IRequestGetCustomerByClientIpoCampaignPageAction extends Action {
    type: ClientIpoCampaignActionType.REQUEST_GET_CUSTOMERS;
    item: GetCustomersByIpoCampaignPageRequest;
}
export interface ICallbackGetCustomerByClientIpoCampaignPageAction extends Action {
    type: ClientIpoCampaignActionType.CALLBACK_GET_CUSTOMERS;
    isSuccess: boolean;
    item?: GetCustomersByClientIpoCampaignPageResponse;
}

export type ClientIpoCampaignAction =
    IRequestGetCustomerByClientIpoCampaignPageAction |
    ICallbackGetCustomerByClientIpoCampaignPageAction;

export interface IClientIpoCampaignActionCreator {

    requestGetCustomerByClientIpoCampaignPageAction(
        item: GetCustomersByIpoCampaignPageRequest
    ): IRequestGetCustomerByClientIpoCampaignPageAction;

    callbackGetCustomerByClientIpoCampaignPageAction(
        isSuccess: boolean,
        item?: GetCustomersByClientIpoCampaignPageResponse,
    ): ICallbackGetCustomerByClientIpoCampaignPageAction;

}

class ActionCreator implements IClientIpoCampaignActionCreator {

    public requestGetCustomerByClientIpoCampaignPageAction = (
        item: GetCustomersByIpoCampaignPageRequest
    ): IRequestGetCustomerByClientIpoCampaignPageAction => {
        return {
            type: ClientIpoCampaignActionType.REQUEST_GET_CUSTOMERS,
            item,
        };
    };

    public callbackGetCustomerByClientIpoCampaignPageAction = (
        isSuccess: boolean,
        item?: GetCustomersByClientIpoCampaignPageResponse,
    ): ICallbackGetCustomerByClientIpoCampaignPageAction => {
        return {
            type: ClientIpoCampaignActionType.CALLBACK_GET_CUSTOMERS,
            isSuccess,
            item,
        };
    };

}

export const createClientIpoCampaignActionCreator = (): IClientIpoCampaignActionCreator => {
    return new ActionCreator();
};



// WEBPACK FOOTER //
// ./src/presentation/action/client_ipo_campaign.ts